import React, {Component} from 'react';
import PropTypes from "prop-types";
import TimePicker from "rc-time-picker";
import classnames from "classnames";
import validator from "validator";
import {addBook} from "../../store/actions/book";
import {connect} from "react-redux";
import {setErrors} from "../../store/actions/error";


const format = 'hh:mm A';

class AddBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      from: {
        value: null,
        isValid: false
      },
      to: {
        value: null,
        isValid: false,
        touched: false,
        errorMessage: 'Please select valid time.'
      },
      poNumber: {
        value: '',
        isValid: false,
        touched: false
      },
      truckNumber: {
        value: '',
        isValid: false,
        touched: false
      },
      formValid: false
    };
    this.changeHandler = this.changeHandler.bind(this)
  }

  componentWillUnmount() {
    this.props.setErrors(null);
  }

  onTimeChange(value, field) {
    this.props.setErrors(null);
    let isValid = this.state[field].isValid;
    let touched = false;

    if (field === 'from') {
      isValid = !!value;
    } else {
      const {from} = this.state;

      isValid = value.isAfter(from.value);
      touched = true;
    }

    this.setState({
      [field]: {
        ...this.state[field],
        value,
        isValid,
        touched
      }
    }, this.validateForm);
  }

  validateForm() {
    const {to, from, truckNumber, poNumber} = this.state;
    this.setState({
      formValid: to.isValid && from.isValid && truckNumber.isValid && poNumber.isValid
    });
  }

  changeHandler(ev) {
    const name = ev.target.name;
    const value = ev.target.value;

    this.setState({
      [name]: {
        ...this.state[name],
        value
      }
    }, () => this.validateField(name, value));
  }

  validateField(fieldName, value) {
    let isValid = !validator.isEmpty(value);

    this.setState({
      [fieldName]: {
        ...this.state[fieldName],
        isValid: isValid
      }
    }, this.validateForm);
  }

  onSubmit(ev) {
    ev.preventDefault();

    if (this.state.formValid) {
      const {to, from, poNumber, truckNumber} = this.state;
      const {slotInfo} = this.props;
      const day = slotInfo.start.getDate();
      to.value.date(day);
      from.value.date(day);

      const body = {
        dock: slotInfo.resourceId,
        po_number: poNumber.value,
        truck_number: truckNumber.value,
        start_date: from.value.format(),
        end_date: to.value.format()
      };

      this.props.addBook(body, this.props.onModalClose);
    }
  }

  render() {
    const {onModalClose, errors} = this.props;
    const {to, from, poNumber, truckNumber} = this.state;

    return (
        <div className="popup">
          <div className="btn-close">
            <button onClick={onModalClose} className="btn btn-link"><i
                className="icon-close"> </i></button>
          </div>
          <div className="container">
            <div className="row justify-content-center">
              <form className="col-md-8" onSubmit={this.onSubmit.bind(this)}>
                <div className="form-title">
                  <h1>Add booking</h1>
                </div>
                <label>Booking time</label>
                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <label>From</label>
                      <TimePicker
                          showSecond={false}
                          className="form-control"
                          format={format}
                          use12Hours
                          value={from.value}
                          onChange={value => this.onTimeChange(value, 'from')}
                      />
                    </div>
                  </div>
                  <div className="col">
                    <div className={classnames('form-group', {'invalid': (!to.isValid && to.touched) || errors})}>
                      <label>To</label>
                      <TimePicker
                          showSecond={false}
                          className="form-control"
                          format={format}
                          use12Hours
                          inputReadOnly
                          value={to.value}
                          onChange={value => this.onTimeChange(value, 'to')}
                          disabled={!from.value}
                      />
                      {!to.isValid && to.touched && (<p className="error-msg">{to.errorMessage}</p>)}
                      {errors && (<p className="error-msg">The docker is already booked for this time.</p>)}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <input type="text" className="form-control" placeholder="PO number" name="poNumber"
                         value={poNumber.value} onChange={this.changeHandler}/>
                </div>
                <div className="form-group">
                  <input type="text" className="form-control" placeholder="Truck number" name="truckNumber"
                         value={truckNumber.value} onChange={this.changeHandler}/>
                </div>
                <div className="form-group text-right mb-4">
                  <button onClick={onModalClose} type="button" className="btn btn-lg btn-secondary mr-3">Cancel
                  </button>
                  <input disabled={!this.state.formValid} type="submit" className="btn btn-lg btn-primary" value="Add"/>
                </div>
              </form>
            </div>
          </div>
        </div>
    );
  }
}

AddBooking.propTypes = {
  onModalClose: PropTypes.func.isRequired,
  slotInfo: PropTypes.any,
  addBook: PropTypes.func.isRequired,
  errors: PropTypes.any,
  setErrors: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  addBook: (body, closeModal) => dispatch(addBook(body, closeModal)),
  setErrors: errors => dispatch(setErrors(errors))
});

const mapStateToProps = state => ({
  errors: state.error.errors
});

export default connect(mapStateToProps, mapDispatchToProps)(AddBooking);



// WEBPACK FOOTER //
// ./src/components/popups/AddBooking.jsx